export default function Footer() {
  return (
    <div className="max-w-sm my-0 mx-auto flex items-center justify-center">
      <div className="fixed z-[-1] bottom-0">
        <p className="text-sm text-slate-500/40 dark:text-slate-400/50">v 0.21</p>
      </div>
    </div>
  )
}
